import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlaySidePanelService } from './services/overlay-side-panel.service';
import { OverlaySidePanelComponent } from './components/overlay-side-panel/overlay-side-panel.component';
import { OverlaySidePanelHeaderComponent } from './components/overlay-side-panel-header/overlay-side-panel-header.component';
import { OverlaySidePanelContentComponent } from './components/overlay-side-panel-content/overlay-side-panel-content.component';
import { OverlaySidePanelFooterComponent } from './components/overlay-side-panel-footer/overlay-side-panel-footer.component';

@NgModule({
  imports: [CommonModule],
  providers: [OverlaySidePanelService],
  declarations: [
    OverlaySidePanelComponent,
    OverlaySidePanelHeaderComponent,
    OverlaySidePanelContentComponent,
    OverlaySidePanelFooterComponent,
  ],
  exports: [
    OverlaySidePanelComponent,
    OverlaySidePanelHeaderComponent,
    OverlaySidePanelContentComponent,
    OverlaySidePanelFooterComponent,
  ],
})
export class OverlaySidePanelModule {}
